import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserForm from './UserForm';

class Edit extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      user,
      searchValue,
      searchQuery,
    } = this.props;
    return (
      <UserForm
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        user={user}
        searchValue={searchValue}
        searchQuery={searchQuery}
      />
    );
  }
}

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  user: PropTypes.object,
  searchValue: PropTypes.string,
  searchQuery: PropTypes.func,
};

Edit.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  user: {},
  searchValue: '',
  searchQuery: () => {},
};

export default Edit;
